<template>
    <div class="suspended-member-wrapper" :class="{ 'is-suspended': suspended }">
        <!-- Existing card layout stays intact underneath -->
        <div class="suspended-member-content" :aria-hidden="suspended ? 'true' : null" :inert="suspended || null">
            <slot />
        </div>

        <!-- Non-destructive visual layer shown only when the member is suspended -->
        <div v-if="suspended" class="suspended-member-layer" role="note" :aria-label="message" :title="message">
            <i class="pi pi-lock suspended-member-icon" aria-hidden="true"></i>
            <p class="suspended-member-message">{{ message }}</p>
            <slot name="action">
                <span class="suspended-member-hint">Upgrade plan to restore access</span>
            </slot>
        </div>
    </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
    suspended: {
        type: Boolean,
        default: false
    },
    memberType: {
        type: String,
        default: 'member',
        validator: (value) => ['tutor', 'student', 'member'].includes(value)
    }
});

const message = computed(
    () => `Account locked — this ${props.memberType} exceeds your current plan's capacity. `
        + `Upgrade your plan to restore access.`
);
</script>

<style scoped>
.suspended-member-wrapper {
    position: relative;
    height: 100%;
}

.suspended-member-content {
    height: 100%;
}

.is-suspended .suspended-member-content {
    filter: grayscale(100%);
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
}

.suspended-member-layer {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 1rem;
    text-align: center;
    border-radius: 8px;
    background: rgba(32, 32, 32, 0.6);
    z-index: 2;
}

.suspended-member-icon {
    font-size: 2.6rem;
    color: #ffffff;
    background: #242424;
    border-radius: 50%;
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}

.suspended-member-message {
    margin: 0;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.35;
    color: #ffffff;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
}

.suspended-member-hint {
    display: inline-block;
    padding: 0.35rem 0.85rem;
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 700;
    color: #5a3d00;
    background: #ffd54a;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
</style>
